export default "__VITE_ASSET__CH771rMu__"